import { DealCardsBidResultsActionTypes, DealCardsBidResultsActionUnion } from './actions';
import { DealCardsBidResultsState } from './state';

export const initialDealCardsBidResultsState: DealCardsBidResultsState = {};

export function dealCardsBidResultsReducer(
    state: DealCardsBidResultsState = initialDealCardsBidResultsState,
    action: DealCardsBidResultsActionUnion
): DealCardsBidResultsState {
    switch (action.type) {
        case DealCardsBidResultsActionTypes.LoadDealCardsBidResultsSuccess:
            return {
                ...state,
                [action.dealId]: {
                    bidResults: action.payload,
                    error: null
                }
            };
        case DealCardsBidResultsActionTypes.LoadDealCardsBidResultsFail:
            return {
                ...state,
                [action.dealId]: {
                    bidResults: null,
                    error: action.payload
                }
            };
        default:
            return state;
    }
}
